import React, { Component } from 'react'
import * as R from 'ramda'
import SearchInput from '@components/SearchInput'
import SearchResultBlock from './SearchResultBlock'
import { ReactComponent as Close } from '@assets/svgs/icons/cross.svg'
import PropTypes from 'prop-types'
import { Index } from 'elasticlunr'
import { indexMap } from '@helpers'
import { constructPageLink } from '@helpers/LinkHelper'
import { navigateTo } from 'gatsby-link'
import './ModalSearch.module.scss'

class ModalSearch extends Component {
  state = {
    query: '',
    results: []
  }

  componentDidMount () {
    document.addEventListener('keydown', this.closeModalSearchOnEscKey)
  }

  componentWillUnmount () {
    document.removeEventListener('keydown', this.closeModalSearchOnEscKey)
  }

  closeModalSearchOnEscKey = (e) => {
    if (e.keyCode === 27) {
      this.props.close(e)
    }
  }

  getOrCreateIndex = () => {
    const { data } = this.props
    return this.index || Index.load(R.prop('index', data))
  }

  onInputChange = evt => {
    const query = R.pathOr('', ['target', 'value'], evt)

    if (query.length < 3) {
      this.setState({ query, results: [] })
      return
    }

    this.index = this.getOrCreateIndex()
    const searchResults = this.index.search(query, {
      fields: {
        productCode: { boost: 1 },
        title: { bool: 'AND', boost: 2 },
        text: { bool: 'AND', boost: 3 },
        caseStudyText: { bool: 'AND', boost: 3 },
        newsText: { bool: 'AND', boost: 3 }
      },
      expand: true
    })
    const getResults = R.map(({ ref }) => this.index.documentStore.getDoc(ref))
    this.setState({
      query,
      results: getResults(searchResults)
    })
  }

  onSubmitForm = (e) => {
    e.preventDefault()

    const { results, query } = this.state

    if (results.length > 1) {
      navigateTo(`/search-results/?query=${query}`)
    } else if (results.length === 1) {
      const templateType = R.path(['0', 'templateType'], results)

      if (R.equals(templateType, 'ContentfulBrochuresComponent')) {
        const brochure = R.pathOr('/', ['0', 'brochure'], results)
        window.location.replace(brochure)
      } else {
        const { slug, templateType, category, id } = R.propOr({}, '0', results)
        const link = constructPageLink(slug, templateType, category, id)
        navigateTo(link)
      }
    } else {
      query.length ? navigateTo(`/search-results/?query=${query}`) : navigateTo(`/search-results`)
    }
    this.props.close(e)
  }

  renderProductResults = (results) => {
    const { close } = this.props
    const indexMap = R.addIndex(R.map)

    return R.pipe(
      R.filter((item) => R.not(R.equals(R.prop('image', item), null))),
      indexMap((res, index) => (
        <SearchResultBlock
          key={index}
          type='product'
          onClick={close}
          {...res}
        />
      ))
    )(results)
  }

  renderPagesResults = (results) => {
    const { close } = this.props

    return R.pipe(
      R.filter((item) => R.equals(R.prop('image', item), null)),
      indexMap((res, index) => (
        <SearchResultBlock
          key={index}
          type='page'
          onClick={close}
          {...res}
        />
      ))
    )(results)
  }

  render () {
    const { close, location } = this.props
    const { results, query } = this.state
    const sortResults = R.pipe(
      R.filter((item) => R.not(R.equals(R.prop('slug', item), null))),
      R.sort((a, b) => {
        if (a.title.toLowerCase() < b.title.toLowerCase()) return -1
        if (a.title.toLowerCase() > b.title.toLowerCase()) return 1
        return 0
      })
    )
    const sortedResults = sortResults(results)

    return (
      <div styleName='background'>
        <span styleName='close' onClick={close}>
          <Close />
        </span>
        <div styleName='search-block'>
          <SearchInput
            onInputChange={this.onInputChange}
            onSubmitForm={this.onSubmitForm}
            input={query}
            location={location}
            close={close}
          />
          {results.length > 0 && (
            <div styleName='search-result-wrapper'>
              {this.renderProductResults(sortedResults)}
              {this.renderPagesResults(sortedResults)}
            </div>
          )}
        </div>
      </div>
    )
  }
}

ModalSearch.propTypes = {
  data: PropTypes.object.isRequired
}

export default ModalSearch



// WEBPACK FOOTER //
// ./src/components/ModalSearch/ModalSearch.js